<template>
  <div class="trademark-registration buy-cps">
    <trademarkHeader></trademarkHeader>
    <div class="domain-content c3">
      <div class="tc section-name f24 fix">
        <div class="black-point fl"></div>
        <div class="fl">一站式服务</div>
        <div class="black-point fl"></div>
        <div class="fl">最快一分钟极速申请</div>
        <div class="black-point fl"></div>
        <div class="fl">专业人员全程指导</div>
      </div>
      <div class="recommend-pro fix auto">
        <div class="recommend-pro-item tc"
             v-for="(item,i) in recommendList"
             :key="i">
          <div v-if="item.isDiscount"
               class="isDiscount">
            <img src="../static/assets/rexiao-icon.png"
                 alt="">
            <span class="rexiao-word">热销</span>
          </div>
          <img :src="item.iconPath"
               alt="">
          <div class="item-name mt30 f18">{{item.name}}</div>
          <div class="item-price f14 mt10"><span class="f18 colorJ">￥</span><span class="f30 colorJ">{{item.price}}</span><span class="f20 colorJ">.{{item.decimal}}</span> <span v-if="item.code !=='2'">起</span></div>
          <div class="mt60">
            <div class="mt10 recommend-desc-item lh18 auto"
                 v-for="(sitem,s) in item.desc"
                 :key="s">
              <img class="mr10"
                   style="vertical-align: text-bottom;"
                   src="../static/assets/allow-transform_03.png"
                   alt="">
              <span class="lh18 f16">{{sitem}}</span>

            </div>
          </div>

          <div class="mt40 tc mb40">
            <a class="choose-recommend-btn"
               :href="`/trademark/trademark-form?code=${item.code}`">立即注册</a>
          </div>
        </div>
      </div>
      <!-- 
      <div class="mt40 tc mb40">
        <a class="choose-recommend-btn"
           href="/domain/trademark-form">立即注册</a>
      </div> -->
      <div class="register-panel fix bgw">
        <div class=" w1200 auto"
             style="padding-top: 70px;">
          <div class="price-register-tabs tc mb40">
            <div class="fix auto"
                 style="width: 400px;">
              <input type="radio"
                     v-model="activeName"
                     value="first"
                     id="register"
                     name="register-label">
              <label for="register">注册流程</label>
              <input type="radio"
                     value="second"
                     id="price"
                     v-model="activeName"
                     name="register-label">
              <label for="price">资费说明</label>
            </div>

          </div>
          <div v-if="activeName == 'first'"
               class="mb30"
               style="position:relative;">
            <div class="bg-line w1200"></div>
            <h2 class="register-step-item-title">商标注册流程</h2>
            <div v-for="(item,index) in registerStep"
                 :key="index"
                 class="register-step-item tc">
              <div class="num-cycle tc auto">{{index+1}}</div>
              <div class="mt20 c3 f16">{{item.name}}</div>
              <div class="mt10 c9 f12">{{item.desc}}</div>
            </div>
          </div>
          <div v-if="activeName == 'first'"
               style="position:relative;">
            <div class="bg-line w1200"></div>
            <h2 class="register-step-item-title">商标续展流程</h2>
            <div v-for="(item,index) in xzStep"
                 :key="index"
                 class="register-step-item tc"
                 :class="!item.isDes?'xuzhanb':''">
              <div class="num-cycle tc auto">{{index+1}}</div>
              <div class="mt20 c3 f16">{{item.name}}</div>
              <div class="mt10 c9 f12">{{item.desc}}</div>
            </div>
          </div>
          <div v-if="activeName == 'second'"
               class="price-table f14">
            <div class="row fix">
              <div class="col">注册版本</div>
              <div class="col sec">专家辅导版</div>
              <div class="col">担保注册版</div>
              <div class="col">担保注册版</div>
            </div>
            <div class="row fix">
              <div class="col">版本定价</div>
              <div class="col sec colorJ">780元起</div>
              <div class="col colorJ">1580元起</div>
              <div class="col colorJ">1500元</div>
            </div>
            <div class="row fix">
              <div class="col">费用构成</div>
              <div class="col sec">商标局规费及中企服务费</div>
              <div class="col">商标局规费及中企服务费</div>
              <div class="col">商标局规费及中企服务费</div>
            </div>
            <div class="row fix">
              <div class="col"
                   style="height: 70px;">商标局规费</div>
              <div class="col sec">
                <div>300元/类·件</div>
                <div class="c9 mt10 f12">即：1件商标在1个类别中申请10项（含10项）以内的商品。超过10项商品，每超过1项商品加收30元。</div>
              </div>
              <div class="col">
                <div>300元/类·件</div>
                <div class="c9 mt10 f12">即：1件商标在1个类别中申请10项（含10项）以内的商品。超过10项商品，每超过1项商品加收30元。</div>
              </div>
              <div class="col">
                <div>&nbsp;<br />500元/件</div>
                <div class="c9 mt10 f12">&nbsp;&nbsp;<br /></div>
              </div>
            </div>
            <div class="row fix">
              <div class="col">中企服务费</div>
              <div class="col sec">480元，指定项目超出10项不另外收取费用。</div>
              <div class="col">1280元，指定项目超出10项不另外收取费用。</div>
              <div class="col">1000元</div>
            </div>
            <div class="row fix">
              <div class="col"
                   style="height: 80px;">退费条件</div>
              <div class="col sec cp"
                   style="height: 80px;">不退费</div>
              <div class="col">商标注册申请收到商标局核发的《驳回通知书》，即：只要商标申请被商标全部驳回即可以退费。 退费流程：中企收到《驳回通知书》后，会安排管家联系申请人进行退费。</div>
              <div class="col sec cp"
                   style="height: 80px;">不退费</div>
            </div>
            <div class="row fix">
              <div class="col"
                   style="height: 180px;">例如</div>
              <div class="col sec"
                   style="height: 180px;">
                <ul>
                  <li>在1个类别中指定8项商品，费用为：商标局规费300元+中企服务费480元=780元。</li>
                  <li>在1个类别中指定15项商品，费用为：商标局规费300+（15-10）×30=450元+中企服务费480元=930元。</li>
                  <li>在2个类别中分别指定10项商品，费用为：商标局规费300×2=600元+中企服务费480×2元=1560元。</li>
                </ul>

              </div>
              <div class="col"
                   style="height: 180px;">
                <ul>
                  <li>在1个类别中指定8项商品，费用为：商标局规费300元+中企服务费1280元=1580元。</li>
                  <li>若申请不成功，退还您的费用为1580元。</li>
                  <li>在1个类别中指定15项商品，费用为：商标局规费300+（15-10）×30=450元+中企服务费1280元=1730元。</li>
                  <li>若申请不成功，退还您的费用为1730元。</li>
                  <li>在2个类别中分别指定3项商品，费用为：商标局规费300元×2+中企服务费1280元×2=3160元。</li>
                  <li>若申请不成功，退还您的费用为3160元。</li>
                </ul>

              </div>
              <div class="col"
                   style="height: 180px;">无</div>
            </div>
          </div>
        </div>
        <div class="w1200"
             style="padding-top: 90px;">
          <div class="tc f24 c3"
               style="margin-bottom: 38px;">服务优势</div>
          <div class="fix pb40">
            <div v-for="(item,r) in serverAdvantageList"
                 :key="r"
                 class="serverAdvantage-item fl">
              <div class="serverAdvantage-item-title">{{item.title}}</div>
              <div class="serverAdvantage-item-desc">{{item.desc}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="w1200 common-question"
           style="padding-top: 80px;line-height: 25px;">
        <div class="tc f24 c3 mb50">常见问题</div>
        <div class="f14 c9">
          <p class="question-title c3">
            1.什么是商标？什么是注册商标？
          </p>
          <p>
            <span>商标是指任何能够将自然人、法人或者其他组织的商品/服务与他人的商品/服务区别开的标志，包括文字、图形、字母、数字、三维标志、颜色组合和声音等，以及上述要素的组合。</span>
          </p>
          <p>
            <span>注册商标是指经过商标主管机关依照法定程序及标准进行审查并通过，经《初步审定公告》无人提出异议的商标。</span>
          </p>
          <p>
            <br />
          </p>
          <p class="question-title c3">
            2.商标注册有风险吗？
          </p>
          <p>
            <span>商标注册存在被商标局驳回导致申请失败的风险。申请驳回失败原因可能有：受可用文字、标识资源限制，新的商标申请容易与在先申请的商标产生近似；法律法规的相关限制等。据不完全的统计，2017年我国商标申请的驳回率约50%，2018年我国商标申请的驳回率约40%。为提高商标注册成功率，申请人可在申请时提前做好应对准备。</span>
          </p>
          <p>
            <span>　</span><span>建议：</span>
          </p>
          <p>
            <span>　(1) 申请时将中文、英文、图形等分开申请，通过后可以组合使用，以避免因某一部分近似而被商标局整体驳回的情况，且分开申请可以根据场景灵活组合使用；</span>
          </p>
          <p>
            <span>　(2) 准备备用方案，申请时可以在主要商标申请方案的基础上，增加一到两件备用商标，以便在主商标无法通过或全部通过的情况下，有其他可以使用的商标。</span>
          </p>
          <p>
            <br />
          </p>
          <p class="question-title c3">
            3.商标申请递交多久后可以在商标网上检索到信息？
          </p>
          <p>
            <span>商标申请递交商标局后，商标局会对申请进行书式审查和形式审查，通过审查后，商标局会在商标网查询系统上公开商标申请信息，公开信息包括：申请人名称，申请人地址，申请商标图样，申请时间，申请商标指定的类别和类似组群以及选择的商品/服务项目等信息。一般情况下，在商标申请递交到商标局之后的2-4周内能够查询到商标申请信息，如有补正等情况，可能会延迟一段时间，具体时间由商标局审查时间决定。</span>
          </p>
          <p>
            <br />
          </p>
          <p class="question-title c3">
            4.商标注册申请需要多长时间？
          </p>
          <p>
            <span>自商标递交之日起，需要经过形式审查、实质审查及初步审定公告，若商标审查顺利，无补正、驳回、异议等意外情况，按照目前的实务审查情况，12个月左右可以领取到《商标注册证》。</span>
          </p>
          <p>
            <span>　商标审查时间主要由以下几个阶段构成：</span>
          </p>
          <p>
            <span>　形式审查：自递交之日起1个月左右完成，审查合格后商标局核发《商标受理通知书》。</span>
          </p>
          <p>
            <span>　实质审查：自递交之日起6个月左右完成，审核通过核发《初步审定公告通知书》，不通过或部分通过核发《驳回通知书》或《部分驳回通知书》。</span>
          </p>
          <p>
            <span>　《初步审定公告》：公告期3个月。</span>
          </p>
          <p>
            <span>　注册证书制证期：注册证书排版、打印、发文等工作，约2个月左右。</span>
          </p>
          <p>
            <br />
          </p>
          <p class="question-title c3">
            5.什么是商标续展？
          </p>
          <p>
            <span>商标续展是指商标注册人在商标注册有效期届满前12个月内或有效期届满后6个月内，依法办理一定的手续，延长其注册商标有效期的制度。期满未办理续展手续的，注销其注册商标。</span>
          </p>
          <p>
            <br />
          </p>
          <p class="question-title c3">
            6.商标续展需要多久？
          </p>
          <p>
            <span>完成商标续展手续会经过：商标续展注册申请、商标局审查、核发续展证明，完成整个时间大约需要4-6个月左右。</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import trademarkHeader from '../src/components/new-header-trademark'
import zjzdIcon from '../static/assets/zjfd-icon.png'
import dbzcIcon from '../static/assets/dbzc-icon.png'
import sbxzIcon from '../static/assets/sbxz-icon.png'
export default {
  data () {
    return {
      activeName: 'first',
      domainSuffixs: [],
      serverAdvantageList: [{
        title: '注册评估低风险',
        desc: '商标注册存在驳回失败风险，中企动力利用大数据分析和先进搜索技术快速甄别类似商标注册信息及状态，帮助提高通过率。'
      }, {
        title: '服务过程担保',
        desc: '服务交易过程担保，先提供专家咨询服务，确定需求后打款，保障用户资金更加安全。'
      }, {
        title: '申报进度实时掌握',
        desc: '申请不再依靠“excel+ 纸”的方式，关键节点短信、邮件通知，申请进度第一时间知晓。'
      }, {
        title: '多种服务供您选择',
        desc: '中企动力为您提供专业服务，可一对一进行问题解答与业务建议，满足您多元的商标需求。'
      }],
      recommendList: [
        {
          code: '0',
          iconPath: zjzdIcon,
          isDiscount: false,
          name: '专家辅导版',
          price: '780',
          decimal: '00',
          desc: [
            '专业人员全流程服务',
            '商标检索分析，评估成功率',
            '优化注册方案，全方位保护'
          ]
        },
        {
          code: '1',
          iconPath: dbzcIcon,
          name: '担保注册版',
          price: '1580',
          decimal: '00',
          desc: [
            '专业人员精准评估',
            '商标检索分析，评估成功率',
            '风险共担，注册失败全额退款'
          ]
        },
        {
          code: '2',
          iconPath: sbxzIcon,
          name: '商标续展',
          price: '1500',
          decimal: '00',
          desc: [
            '商标期满前12个月内申请',
            '快速提交，拒绝繁琐',
            '专家辅助，高性价比服务方案'
          ]
        }
      ],
      registerStep: [
        {
          name: '专家评估',
          isDes: true,
          desc: '1个工作日'
        },
        {
          name: '材料审核',
          isDes: true,
          desc: '1个工作日'
        },
        {
          name: '提交商标局',
          isDes: true,
          desc: '1-2个月形式审查'
        },
        {
          name: '受理通过',
          isDes: true,
          desc: '3-4个月实质审查'
        },
        {
          name: '初审公告',
          isDes: true,
          desc: '3个月异议期'
        },
        {
          name: '注册公告',
          isDes: true,
          desc: '1-2个月公告期'
        },
        {
          name: '注册成功',
          isDes: false,
          desc: ''
        }
      ],
      xzStep: [
        {
          name: '专家联系',
          isDes: true,
          desc: '1个工作日'
        },
        {
          name: '提交续展',
          isDes: true,
          desc: '1-2个月'
        },
        {
          name: '实质审查',
          isDes: true,
          desc: '3-6个月'
        },
        {
          name: '续展成功',
          isDes: false,
          desc: ''
        }
      ]
    }
  },
  components: {
    trademarkHeader
  },
}
</script>

<style lang="scss">
.trademark-registration {
  .cp {
    color: #20a596;
  }
  .bgw {
    background: #fff;
  }
  .w1000 {
    width: 930px;
  }
  .c3 {
    color: #333;
  }
  .c9 {
    color: #999;
  }
  .lh18 {
    line-height: 18px;
  }
  .w1200 {
    width: 1200px;
  }
  .colorJ {
    color: #ff9900;
  }
  .f24 {
    font-size: 24px;
  }
  .isDiscount {
    position: absolute;
    right: -8px;
    top: -3px;

    .rexiao-word {
      position: absolute;
      top: 16px;
      right: 13px;
      color: #fff;
    }
  }
  .company-domain-server {
    padding-top: 50px;
    background: #fff;
  }
  .price-table {
    line-height: 20px;
    li {
      list-style: disc;
    }
    .col {
      width: 342px;
      border-right: 1px solid #e5e5e5;
      border-bottom: 1px solid #e5e5e5;
      padding: 30px;
      float: left;
    }
    .row .col:first-child {
      width: 71px;
      height: 100%;
      background: #f6f8fa;
    }
    .row:first-child {
      background: #f6f8fa;
    }
    .col:last-child {
      width: 200px;
      border-right: 0;
    }
  }
  .bg-line {
    position: absolute;
    z-index: 99;
    top: 63px;
    height: 1px;
    background: #e5e5e5;
  }
  .bg-line2 {
    position: absolute;
    z-index: 99;
    top: 228px;
    height: 1px;
    background: #e5e5e5;
  }
  .register-step-item-title {
    font-size: 20px;
    margin-bottom: 20px;
  }
  .register-step-item {
    position: relative;
    vertical-align: top;
    background: #fff;
    z-index: 100;
    width: 126px;
    margin-right: 53px;
    display: inline-block;
  }
  .register-step-item:last-child {
    margin-right: 0;
  }
  .register-step-item.xuzhanb {
    padding-right: 537px;
  }
  .num-cycle {
    width: 30px;
    height: 30px;
    line-height: 30px;
    border: 2px solid #20a596;
    border-radius: 50%;
  }
  .section-name {
    width: 625px;
    margin: auto;
    margin-top: 78px;
    margin-bottom: 35px;
    font-size: 24px;

    .black-point {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #000;
      margin: 10px 3px 10px 20px;
    }

    // div {
    //   vertical-align: middle;
    // }
  }
  .recommend-pro-item {
    position: absolute;
    width: 360px;
    height: 400px;
    padding: 60px 50px;
    background: #fff;
    border: 1px solid #eeeeee;

    .recommend-desc-item {
      width: 241px;
      margin: auto;
      text-align: left;
    }
  }
  .recommend-pro-item:hover {
    z-index: 990;
    top: -4px;
    padding: 64px 50px;
    box-shadow: 5px 5px 10px 0 #dddddd;

    .choose-recommend-btn {
      background: #20a596;
      color: #ffffff;
    }
  }
  .choose-recommend-btn {
    display: inline-block;
    width: 300px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: #ffffff;
    color: #20a596;
    border: 1px solid;
  }
  .domain-server-item {
    width: 590px;
    height: 120px;
    background: #fff;
  }
  .domain-server-item:hover {
    box-shadow: 5px 5px 10px #dddddd;
  }
  .domain-detail-btn {
    background: #fff;
    padding: 10px 30px;
    border: 1px solid #cccccc;
  }
  .domain-content {
    .yfriend {
      padding-bottom: 134px;
      section {
        padding: 0;
        img {
          width: 192px;
        }
      }
    }
    .recommend-pro {
      position: relative;
      width: 1384px;
      height: 600px;
    }
    .recommend-pro-item:nth-child(2) {
      left: 461px;
    }
    .recommend-pro-item:last-child {
      right: 0;
    }
  }
  .price-register-tabs {
    border-bottom: 1px solid #dddddd;
    label {
      position: relative;
      bottom: -1px;
      text-align: center;
      float: left;
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      width: 200px;
      cursor: pointer;
    }
    input:checked + label {
      border-bottom: 2px solid #20a596;
    }
    input {
      visibility: hidden;
      position: absolute;
    }
  }
  .serverAdvantage-item {
    width: 283px;
    border: 1px solid #eaeaea;

    .serverAdvantage-item-title {
      height: 80px;
      font-size: 22px;
      line-height: 80px;
      text-align: center;
      background: #f8f9fa;
    }
    .serverAdvantage-item-desc {
      height: 140px;
      padding: 30px 20px 0 20px;
      line-height: 30px;
      font-size: 14px;
    }
  }
  .serverAdvantage-item:not(:first-child) {
    margin-left: 20px;
  }
  .common-question {
    p {
      padding-left: 14px;
    }
    .question-title {
      padding-left: 0;
      margin-bottom: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/trademark.vue